function getFormatDocumentLink(upNeighbor, ext) {
	let documentArea = document.querySelectorAll('.documents-area .title-area');

	for(let i = 0; i < documentArea.length ; i++) {
		upNeighbor = documentArea[i].previousElementSibling;
		ext = documentArea[i].dataset['ext'];
		insetClassIcon(upNeighbor, ext);
	}
}

function insetClassIcon(upNeighbor, ext) {
	let icons = [
		{ext: ['pdf'], 'class': 'fa-file-pdf'},
		{ext: ['png', 'jpg', 'jpeg'], 'class': 'fa-file-image'},
		{ext: ['doc', 'docx'], 'class': 'fa-file-word'},
	];

	for(let i of icons) {
		if (i.ext.indexOf(ext) !== -1) {
			let classIcon = i.class;
			upNeighbor.classList.remove('fa-file-lines');
			upNeighbor.classList.add(classIcon);
			return;
		}
	}
}

getFormatDocumentLink();